import Box from "@mui/material/Box";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableContainer from "../Tables/TableContainer";
import TableCell from "../../pages/BillingAndPayments/components/TableCell";
import { useTranslationApp } from "../../lib/i18next";
import {
  ORGANIC_PUBLISH_RETRY_ALERT_ARIA_LABEL,
  ORGANIC_PUBLISH_RETRY_ALERT_COLUMN_MESSAGE,
  ORGANIC_PUBLISH_RETRY_ALERT_COLUMN_PLATFORM,
} from "../../i18n/keysTranslations";

const OrganicPublishRetryFailuresTable = ({ rows = [] }) => {
  const { t } = useTranslationApp();
  const rowKeys = rows.map((_, idx) => String(idx));

  return (
    <Box sx={{ width: "100%", maxWidth: "100%" }}>
      <TableContainer
        keys={rowKeys}
        loading={false}
        ariaLabel={t(ORGANIC_PUBLISH_RETRY_ALERT_ARIA_LABEL)}
        hasPagination={false}
        showEmptyText={false}
      >
        <TableHead>
          <TableRow>
            <TableCell
              isHeader
              sx={{
                pl: "16px !important",
                cursor: "default",
                width: "30%",
                maxWidth: "36%",
              }}
            >
              {t(ORGANIC_PUBLISH_RETRY_ALERT_COLUMN_PLATFORM)}
            </TableCell>
            <TableCell
              isHeader
              sx={{ cursor: "default", width: "70%", minWidth: "200px" }}
            >
              {t(ORGANIC_PUBLISH_RETRY_ALERT_COLUMN_MESSAGE)}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => {
            const isLastRow = index === rows.length - 1;
            return (
              <TableRow key={rowKeys[index]}>
                <TableCell
                  indexRow={index}
                  isLastRow={isLastRow}
                  sx={{
                    pl: "16px !important",
                    cursor: "default",
                    verticalAlign: "top",
                  }}
                >
                  {row.platformLabel}
                </TableCell>
                <TableCell
                  indexRow={index}
                  isLastRow={isLastRow}
                  sx={{
                    cursor: "default",
                    verticalAlign: "top",
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    overflow: "visible",
                    textOverflow: "unset",
                    height: "auto",
                  }}
                >
                  {row.message}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </TableContainer>
    </Box>
  );
};

export default OrganicPublishRetryFailuresTable;
